import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { Helper } from '../../Helper';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, NgForm } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { MatTabGroup, MatTab } from '@angular/material';

@Component({
  selector: 'am-next-tab-button',
  templateUrl: './next-tab-button.component.html',
  styleUrls: ['./next-tab-button.component.css', '../../sub-admin/subadmin.component.css', '../../../assets/bootstrap.css']



})
export class NextTabButtonComponent implements OnInit {

  constructor(public Helper: Helper, private route: ActivatedRoute) {

  }
  per_page = 25
  @Output() onChange = new EventEmitter;
  @Input() form: FormGroup;
  @Input() showOnlast=false ;
  @Input() formElement;
  @Output() onSubmit= new EventEmitter;

  @Input() tab: MatTabGroup;
  @Input() parentTab: MatTabGroup;
  show = true;

  ngOnInit() {

    // if(this.tab._tabs.length==this.tab.selectedIndex){
    //   this.show=false;
    // }
    if (this.tab) {
      if (this.formElement) {
        this.formElement.addEventListener("submit", (e) => {
          // console.log("this.tab","submittedd")
          this.checkValidations()
        });
      }
      // console.log("this.tab",this.formElement,"----",this.tab,this.form,this.tab.selectedIndex)

      this.tab.animationDone.subscribe(data => {
        if (this.tab._tabs.length == this.tab.selectedIndex + 1) {
          this.show = false;
        }
        else {
          this.show = true;


        }
      })
    }

  }

  checkValidations() {
    let hasError = false;
    console.log('this.form.valid', this.form.valid)
    if (this.form && !this.form.valid) {
      for(let i in this.form.controls){
        if (!this.form.controls[i].valid) {
          console.log(i,this.form.controls[i].value,this.form.controls[i].valid, "cntl")
           
        }
      }
      this.looper(0);

      // for(let control in this.form.controls){
      //   console.log(control,this.form.controls[control].valid,document.querySelector('[formControlName="'+control+'"]'))

      // if(  !this.form.controls[control].valid){

      this.Helper.toast("There is some errors in the form, please check again", 'red')
      let breaked = false;
      // for(let i=0; i<this.tab._tabs.length ;i ++){
      //   if(breaked){
      //     break;
      //   }



      // }
      // let index=document.querySelector('[formControlName="'+control+'"]').closest("mat-tab-body").getAttribute("ng-reflect-position");
      // console.log("index",index,control,document.querySelector('[formControlName="'+control+'"]'),document.querySelector('[formControlName="'+control+'"]').closest("mat-tab-body"))
      // this.tab.selectedIndex= (this.tab._tabs.length + parseInt(index));

      // }
    }
  }

  looper(i) {

    this.tab.selectedIndex = i;
    console.log("ind", i)
    let breaked = false;
    setTimeout(() => {
      this.formElement.querySelectorAll('[formControlName]').forEach((el) => {
        if (breaked) {
          return 1;
        }
        let cntl = el.getAttribute("formControlName")
        
        if (!this.form.controls[cntl].valid) {
          console.log(cntl,this.form.controls[cntl].valid, "cntl")
          breaked = true;
        }


      })
      if (breaked) {

      }
      else {
        if (this.tab._tabs.length > i)
          this.looper(i + 1);
      }
    }, 200)




  }
  nextTabInner() {
    let hasError = false;
    if (this.form) {
      for (let control in this.form.controls) {
        if (document.querySelector('[formControlName="' + control + '"]')) {
          this.form.controls[control].markAsTouched();

          if (!this.form.get(control).valid) {
            console.log(hasError, control, 'hasError')
            hasError = true;
          }

        }
      }
    }
    console.log(hasError, 'hasError')
    // if(!hasError)
    // this.tab.selectedIndex=this.tab.selectedIndex+1;
    if (!hasError) {
      console.log(this.tab.selectedIndex, this.tab._tabs.length)
      if (this.tab.selectedIndex != this.tab._tabs.length - 1   ) {
        if(this.onSubmit.observers.length>0)
         {
            this.onSubmit.emit({tab:this.tab.selectedIndex + 1,cb:()=>{
              
              this.tab.selectedIndex = this.tab.selectedIndex + 1;
            }}); 
         }  
         else 
         this.tab.selectedIndex = this.tab.selectedIndex + 1;

        return 1;
      }
      // console.log(this.parentTab.selectedIndex,this.parentTab._tabs.length)
      if (this.parentTab && this.parentTab.selectedIndex != this.parentTab._tabs.length - 1) {
        if(this.onSubmit.observers.length>0)
         {
            this.onSubmit.emit({tab:this.tab.selectedIndex + 1,cb:()=>{
              
              this.parentTab.selectedIndex = this.parentTab.selectedIndex + 1;
            }}); 
         }  
         else 
            this.parentTab.selectedIndex = this.parentTab.selectedIndex + 1;
        return 1;
      }

    }



  }
  checkPrev() {
    if (this.tab.selectedIndex == 0 && this.parentTab && this.parentTab.selectedIndex == 0) {
      return false;
    }
    return true;
  }
  prev() {
    // console.log('0XX', this.tab.selectedIndex, this.parentTab);
    if (this.tab.selectedIndex != 0){
      this.tab.selectedIndex = this.tab.selectedIndex - 1;
    }
    else{
      if (this.parentTab && this.parentTab.selectedIndex > 0) {
        this.parentTab.selectedIndex = this.parentTab.selectedIndex - 1;
        return 1;
      }
    }
    
    
  }
}
